import ComboBox from '../common/ComboBox';

class Space {

  private FrontSelectorComboHTML: HTMLElement;
  private HeightLabel: HTMLElement;
  private HeightHTML: HTMLInputElement;
  private HeightUnit: HTMLSelectElement;

  // TODO: Type the parameters correctly
  constructor(idx: number, data: any, fronts: any[], setScript: () => void, setParameters: () => void) {

    const templates: HTMLElement = document.querySelector<HTMLElement>('[data-id="templates"]')!;
    const template: HTMLElement = templates.querySelector<HTMLElement>('[data-id="Space"]')!;
    const cloned: HTMLElement = template.cloneNode(true) as HTMLElement;

    // setup front selector ComboBox
    this.FrontSelectorComboHTML = cloned.querySelector<HTMLElement>('[data-id="front-selector-combo"]')!;
    const combo: ComboBox = new ComboBox();
    combo.init(this.FrontSelectorComboHTML);
    combo.selectByID(fronts[idx]);
    this.FrontSelectorComboHTML.addEventListener("changed", (e: Event) => {
      const event = e as CustomEvent<{ value: string }>;
      fronts[idx] = event.detail.value;
      console.log("combo value changed: " + fronts[idx]);
      setScript();
      setParameters();
    });

    this.HeightLabel = cloned.querySelector<HTMLElement>('[data-id="height-label"]')!;
    this.HeightHTML = cloned.querySelector<HTMLInputElement>('[data-id="height"]')!;
    this.HeightUnit = cloned.querySelector<HTMLSelectElement>('[data-id="height-unit"]')!;
    if(data.Height != null) {

      const match: RegExpMatchArray | null = data.Height.match(/^(\d+)(auto|mm|\*|\%)$/);

      if (match != null) {
        this.HeightHTML.value = match[1];
        this.HeightHTML.addEventListener("change", () => {
          data.Height = this.HeightHTML.value + this.HeightUnit.value;
          console.log("height changed: " + data.Height);
          setScript();
          setParameters();
        });

        // HeightUnit is a <select> element
        this.HeightUnit.value = match[2];
        this.HeightUnit.addEventListener("change", () => {
          data.Height = this.HeightHTML.value + this.HeightUnit.value;
          this.updateUI(this.HeightUnit.value);
          console.log("height unit changed: " + data.Height);
          setScript();
          setParameters();
        });
      } else {
        console.error("Space: Invalid height data: " + data.Height);
      }

    } else { // hide height when data is null
      this.HeightLabel.classList.add("hidden");
      cloned.querySelector<HTMLElement>('[data-id="height-group"]')!.classList.add("hidden");
    }

    const target: HTMLElement = document.querySelector<HTMLElement>('[data-id="zones"] [data-id="content"]')!;
    
    //target.appendChild(cloned);
    target.insertBefore(cloned, target.firstChild); // reverse visual order
  }

  private updateUI(unit: string): void {
    if(unit === "auto") {
      this.HeightHTML.classList.add("hidden");
    } else {
      this.HeightHTML.classList.remove("hidden");
    }
  }
}

export default Space;
